import React from 'react';
import { locales } from '../../../translations/locales';
import { _$, _setText } from '../../../controllers/dom';

const Message = (props) => {
    const { locale, ModuleRP, vehicle } = props;

    const sendMessage = () => {
        ModuleRP.sendMessageToVehicle(vehicle.id, _$('message').value);
        _$('message').value = '';
        _setText('result', locales[locale].sgo.messageSent);
        setTimeout(() => {
            _setText('result', '');
        }, 3000);
    };

    return (
        <div>
            <h6 className='text-center'>{vehicle.name}</h6>
            <textarea className='form-control' rows='3' placeholder='Message' id='message' />
            <div id='result' className='text-success'></div>
            <button type='button' className='btn btn-sm btn-primary m-1 float-right' onClick={sendMessage}>
                {locales[locale].send}
            </button>
        </div>
    );
};

export default Message;
